export class LoggerLocationFormatter {
    static start(className, methodName) {
        return `${className}>>${methodName}>>start`;
    }
    static step(className, methodName, stepName) {
        return `${className}>>${methodName}>>${stepName || 'unknown-step'}`;
    }
    static end(className, methodName) {
        return `${className}>>${methodName}>>end`;
    }
    static error(className, methodName) {
        return `${className}>>${methodName}>>error`;
    }
}
//# sourceMappingURL=logger-location-formatter.js.map